import { get } from "@src/appV2/api";
import { environmentConfig } from "@src/appV2/environment";
import { useDefinedWorker } from "@src/appV2/Worker/useDefinedWorker";
import { useQuery } from "@tanstack/react-query";
import { z } from "zod";

const workerPaymentsStatsResponseSchema = z.object({
  data: z.object({
    attributes: z.object({
      firstPaymentCreatedAt: z.string().optional(),
      totalEarningsInCents: z.number(),
      availableBalanceInCents: z.number(),
    }),
  }),
});

export function useGetWorkerPaymentsStats(options?: { enabled: boolean }) {
  const worker = useDefinedWorker();

  return useQuery({
    enabled: options?.enabled,
    queryKey: ["worker-payments-stats", worker.userId],
    queryFn: async () => {
      const result = await get({
        url: `${environmentConfig.REACT_APP_PAYMENTS_API_URL}/accounts/${worker.userId}/payments/stats`,
        responseSchema: workerPaymentsStatsResponseSchema,
      });

      return result.data;
    },
    meta: {
      userErrorMessage: "Failed to load payments stats",
    },
  });
}
